<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item ref="query" :model="query">
          <el-input placeholder="请输入关键字" v-model="query.key"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addclerk"
            v-if="actionauth.base_clerk_add == 'true'">新增职员</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="getclerkgroup">新增职员组别</el-button>
          <el-button type="primary" icon="el-icon-location" @click="runinfolistsall(0)">跑店签到记录</el-button>
          <el-button type="danger" icon="el-icon-plus" @click="addsellplan">新增职员销售计划</el-button>
          <el-button type="warning" icon="el-icon-search" @click="checksellplan">查询销售计划</el-button>
        </el-form-item>
      </el-form>
      <!------------------------search end---------------------->

      <!----------------- clert group lists start（新增会员组别列表）------------------>
      <el-dialog title="职员会员组列表" :visible.sync="creategroupDialog" top="4vh">
        <el-button size="medium" type="primary" icon="el-icon-circle-plus-outline" @click="creategroupaddDialog = true"
          v-if="actionauth.base_clerk_group_add == 'true'">新增会员组别</el-button>
        <el-table :data="grouplists" v-loading="groupLoading">
          <el-table-column prop="id" label="编号" width="140"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="是否使用" width="150">
            <template slot-scope="status">
              <el-switch active-color="#ff4949" inactive-color="#cccccc" v-model="status.row.status"
                @change="changestatus(status.$index, status.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150"
            v-if="actionauth.base_clerk_group_edit == 'true' || actionauth.base_clerk_group_del == 'true'">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editgrouppercent(scope.row)"
                v-if="actionauth.base_clerk_group_edit == 'true'"></el-button>
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="deletegrouppercent(scope.row)"
                v-if="actionauth.base_clerk_group_del == 'true'"></el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizegroup" @current-change="pageCurrentgroup" :current-page="group.p"
            :page-sizes="[10, 20, 50]" :page-size="group.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="group_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>
      <!----------------- clert group lists end（新增会员组别列表）-------------------->

      <!----------------- add clert group start（新增会员组别列表）------------------>
      <el-dialog title="新增会员组别" :visible.sync="creategroupaddDialog">
        <el-form ref="clerkrules" :model="clerkrules" :rules="addclerkrules" size="medium">
          <el-col :span="23">
            <el-form-item label="组别名称" prop="name" label-width="15%">
              <el-input v-model="localgroup.name" label-width="60%"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="creategroupaddDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="creategroupLoading" @click="creategroupadd">保 存</el-button>
        </div>
      </el-dialog>
      <!----------------- add clert group end（新增会员组别列表）------------------>

      <!----------------- edit clert group start（新增会员组别列表）------------------>
      <el-dialog title="编辑会员组别" :visible.sync="creategroupeditDialog">
        <el-form ref="editclerkrules" :model="clerkrules" :rules="editclerkrules" size="medium">
          <el-col :span="23">
            <el-form-item label="组别名称" prop="name" label-width="15%">
              <el-input v-model="localgroup.name" label-width="60%"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="creategroupeditDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="creategroupeditLoading" @click="creategroupedit">保
            存</el-button>
        </div>
      </el-dialog>
      <!----------------- edit clert group end（新增会员组别列表）------------------>

      <!------------------------add---------------------->
      <el-dialog title="新增职员" :visible.sync="createDialog">
        <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="medium">
          <el-col :span="14">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="create.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="编号" prop="number">
              <el-input v-model="create.number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="生日">
              <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="出生日期"
                v-model="create.birthday"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="create.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="联系地址">
              <el-input v-model="create.address"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="23">
            <el-form-item label="选择组别">
              <el-select v-model="create.groupid" placeholder="请选择客户分类">
                <el-option label="不分类" value="0"></el-option>
                <el-option v-for="(item, index) in grouplists" :label="item.name" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="createDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------add end---------------------->

      <QrCodeDialog ref="qrCodeDialogRef" />
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading">
          <el-table-column prop="number" label="编号" width="100" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="name" label="职员类型">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.type == 1">直营</el-tag>
              <el-tag v-if="scope.row.type == 2">合作</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" width="140" align="center"></el-table-column>
          <el-table-column prop="name" label="设置负责区域" align="center" width="150" v-if="isopenmall == 1">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" icon="el-icon-edit"
                @click="getcitylists(scope.row)">设置负责区域</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="270"
            v-if="actionauth.base_clerk_edit == 'true' || actionauth.base_clerk_del == 'true'" align="center">
            <template slot-scope="scope">
              <!-- 二维码图标******************* -->
              <span class="down-qr-code" @click="downqrcode(scope.row)"></span>
              

              <el-button type="primary" size="small" circle icon="el-icon-sort"
                @click="changecustomer(scope.row)"></el-button>
              <!--<el-button type="success" size="small" circle icon="el-icon-location" @click="runinfolists(scope.row.id)"></el-button>-->
              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editCurrent(scope.row)"
                v-if="actionauth.base_clerk_edit == 'true'"></el-button>
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delCurrent(scope.row)"
                v-if="actionauth.base_clerk_del == 'true'"></el-button>
              <!--
                <el-tooltip class="item" effect="dark" :content="scope.row.kingdeesubmit==1 ? '订单数据已同步至管易云':'将订单数据同步至管易云'" placement="top" v-if="datacenter=='kingdeecloud'">
                    <el-button :type="scope.row.kingdeesubmit==1 ? 'success' : 'primary'" :icon="scope.row.kingdeesubmit==1 ? 'el-icon-check' :  'el-icon-setting'" size="mini" circle @click="kingdeesellsubmit(scope.row)"></el-button>
                </el-tooltip>
                -->
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
            :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!------------------------edit---------------------->
      <el-dialog title="编辑职员信息" :visible.sync="updateDialog">
        <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="medium">
          <el-col :span="24">
            <el-col :span="14">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="update.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="编号" prop="number">
                <el-input v-model="update.number"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="11">
              <el-form-item label="生日">
                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="出生日期"
                  v-model="update.birthday"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <el-input v-model="update.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="23">
            <el-form-item label="联系地址">
              <el-input v-model="update.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="选择组别">
              <el-select v-model="update.groupid" placeholder="请选择客户分类">
                <el-option label="不分类" value="0"></el-option>
                <el-option v-for="(item, index) in grouplists" :label="item.name" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="updateDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------edit end---------------------->


      <!--------------- 店铺会员跑店记录列表 --------------------->
      <el-dialog title="跑店记录信息列表" :visible.sync="runlogDialog" top="5vh" width="70%">
        <el-row :gutter="12" v-loading="runLoading">
          <el-col :span="24">
            <el-card shadow="hover" :body-style="{ padding: '0px' }"
              style="padding:0px;box-shadow:none;border:1px solid #ebeef5;margin-bottom:20px;hover:box-shadow:0 2px 12px 0 rgba(0,0,0,.1);"
              onmouseover="this.style.cssText='box-shadow:0 2px 12px 0 rgba(0,0,0,.1);transition:All 0.3s ease-in-out;margin-bottom:20px'"
              onmouseout="this.style.cssText='box-shadow:none;transition:All 0.3s ease-in-out;margin-bottom:20px'"
              v-for="(item, index) in signlists" :key="index">

              <div class="card_one">
                <span class="title">签到人名：</span><span class="content">{{ item.clerkname }}</span>
                <span class="title">拜访客户：</span><span class="content">{{ item.customer_name }}</span>
              </div>
              <div class="card_one">
                <span class="title">签到地点：</span>
                <span class="content">{{ item.address }}
                  &nbsp;&nbsp;<el-button type="primary" icon="el-icon-location" circle style="padding:0;"
                    @click="shopmap(item.lat, item.log, item.customer_name, item.address)"></el-button>
                </span>
                <span class="content" style="margin-left:4%">{{ item.inputtime }}</span>
              </div>
              <div class="card_one">
                <span class="title">详细内容：</span><span class="all">{{ item.note }}</span>
              </div>
              <div class="card_one" style="padding:0 4% 3% 4%;border-bottom:0">
                <span class="img" v-for="(images, index) in item.images"><img :src="images" :preview="item.id" /></span>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="signpageSizeChange" @current-change="signpageCurrentChange"
            :current-page="signquery.p" :page-sizes="[10, 20, 50]" :page-size="signquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="sign_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>


      <!-------------- 展示地图信息 ------------------->
      <el-dialog title="地图信息展示" :visible.sync="showmapDialog" top="5vh" width="55%">
        <template>
          <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true"
            v-loading="mapLoading">
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="true"
              :locationIcon="{ size: { width: 18, height: 18 } }" @locationSuccess="getLoctionSuccess"
              @locationError="getLocationError"></bm-geolocation>
            <!-- 自定义定位图标覆盖物 -->
            <bm-marker :position="autoLocationPoint" :dragging="true" :auto-viewport='true'
              animation="BMAP_ANIMATION_BOUNCE" v-if="initLocation">
            </bm-marker>
          </baidu-map>
        </template>
      </el-dialog>

      <!-------------- 销售员客户信息 ------------------->
      <el-dialog :title="clerkname" :visible.sync="customerDialog" top="10vh" width="40%">
        <el-transfer style="text-align: left; display: inline-block" v-model="mycustomer" filterable
          :data="defaultcustomer" :titles="['系统客户', '我的客户']">
        </el-transfer>
        <el-form style="margin-top:20px">
          <el-form-item label="一键移交销售员">
            <el-select v-model="localclerkid" filterable remote style="width:30%" @change="getchangeclerk()">
              <el-option v-for="(item, index) in allclerks" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="customerDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="editclerkcustomer" :loading="editclerkLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 金蝶销售员信息设置 -->
      <el-dialog title="金蝶销售员信息设置" :visible.sync="settingkingdeeDialog" top="10vh" width="27%">
        <el-form ref="create" :model="create" :rules="rules" size="small">
          <el-col :span="24">
            <el-col :span="24">
              <el-form-item label="金蝶业务员类型" label-width="150">
                <el-input v-model="settingkingdeequery.kingdeetype" style="width:60%"></el-input>
                <el-tag type="danger" size="mini">请参照金蝶系统职员列表任职岗位进行填写</el-tag>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="24">
              <el-form-item label="金蝶员工任岗编码" label-width="150">
                <el-input v-model="settingkingdeequery.kingdeecode" style="width:60%"></el-input>
                <el-tag type="danger" size="mini">请参照金蝶系统职员列表员工任岗编码进行填写</el-tag>
              </el-form-item>
            </el-col>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="settingkingdeeDialog = false">取 消</el-button>
          <el-button size="medium" type="danger" @click="savekingdeeinfos">确认</el-button>
        </div>
      </el-dialog>


      <!-- 设置负责区域 -->
      <el-dialog title="设置负责销售区域" :visible.sync="addareaDialog" width="50%" top="10vh">
        <el-tag type="danger" size="small" style="margin:20px 0">温馨提示：该设置主要用于跑店小程序下单时业务员的可视范围内的订单信息</el-tag>
        <el-tree :data="citytrees" ref="citytrees" v-loading="addrealoading" highlight-current show-checkbox
          node-key="id" @check="selectcityids">
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addareaDialog = false">取 消</el-button>
          <el-button type="primary" size="small" @click="saveclerkcitys">保 存</el-button>
        </div>
      </el-dialog>


      <!-- 新增销售员月销售计划 -->
      <el-dialog title="新增销售员月销售计划" :visible.sync="planDialog" width="50%" top="10vh" :before-close="closeplan">
        <div style="float:right">
          <el-button size="small" @click="planDialog = false">取 消</el-button>
          <el-button type="primary" size="small" @click="addclerkplans" :loading="planquery.loading">保 存</el-button>
        </div>
        <el-form :inline="true" class="demo-form-inline" size="small"
          style="float:left;border-bottom:1px solid #dddddd;margin-top:30px">
          <el-form-item size="small">
            <el-select v-model="planinfo.clerkid" placeholder="请选择职员" prop="groupid" clearable>
              <el-option v-for="(item, index) in morelists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small">
            <el-select v-model="planinfo.type" clearable filterable placeholder="请选择时间类型" size="small"
              @changetime="changetimetype">
              <el-option v-for="(item, index) in planinfotypelists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small" v-if="planinfo.type == 1">
            <el-date-picker v-model="planinfo.time1" type="year" value-format="yyyy" placeholder="选择计划年份"
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item size="small" v-if="planinfo.type == 2">
            <el-date-picker v-model="planinfo.time" type="month" value-format="yyyy-MM" placeholder="选择计划月份"
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item size="small">
            <el-input v-model="planinfo.clerkplan" type="text" placeholder="请填写默认计划销售金额" clearable></el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="danger" circle icon="el-icon-plus" size="mini" @click="addplaninfos" />
          </el-form-item>
        </el-form>

        <div style="float:left;width:100%;margin-bottom:30px">
          <div style="float:left;width:100%;padding:20px 0;margin:0;border-bottom:1px dashed #dddddd"
            v-for="(item, index) in planquery.planlists" :key="index">
            <div style="float:left;width:100%;font-size:14px;padding-bottom:5px">{{ item.clerkname }}</div>
            <ul style="float:left;width:100%;margin:0;padding:0">
              <li style="padding:10px 0;float:left;width:100%;list-style-type:none;font-size:13px"
                v-for="(tt, ii) in item.data" :key="index">
                <div style="float:left;width:20%">{{ tt.month }}</div>
                <div style="float:left;width:45%">
                  <el-input placeholder="请输入计划销售金额" size="small" v-model="tt.money" clearable>
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div style="float:right">
                  <el-button type="danger" circle icon="el-icon-delete" size="mini" @click="delplan(index, ii)" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="planDialog = false">取 消</el-button>
          <el-button type="primary" size="small" @click="addclerkplans" :loading="planquery.loading">保 存</el-button>
        </div>
      </el-dialog>


      <!-- 展示销售计划 -->
      <el-dialog title="销售员销售计划" :visible.sync="showplanDialog" width="60%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item size="small">
            <el-select v-model="showplanquery.clerkid" placeholder="请选择职员" prop="groupid" clearable
              @change="showplanquery.ischange">
              <el-option v-for="(item, index) in morelists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small">
            <el-date-picker v-model="showplanquery.month" type="month" clearable value-format="yyyy-MM"
              placeholder="选择计划月份" @change="showplanquery.ischange"></el-date-picker>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" circle icon="el-icon-search" size="mini" @click="getshowplan" />
          </el-form-item>
        </el-form>

        <el-table :data="showplanlists" v-loading="showplanquery.loading">
          <el-table-column prop="clerkname" label="销售员"></el-table-column>
          <el-table-column prop="month" label="月份" width="140"></el-table-column>
          <el-table-column label="计划销售额" width="140" align="center">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.money" placeholder="请填写计划销售额度" size="small"
                @blur="changemoney(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="销售额" width="140" prop="sale" align="center" />
          <el-table-column prop="percent" label="完成任务比例" width="140" align="center"></el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="small" circle icon="el-icon-delete"
                @click="deletemoney(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="showplanSizeChange" @current-change="showplanCurrentChange"
            :current-page="showplanquery.p" :page-sizes="[10, 20, 50]" :page-size="showplanquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="showplanrows">
          </el-pagination>
          <!--分页end-->
        </div>

      </el-dialog>


    </div>
  </transition>
</template>

<script>
import QrCodeDialog from './QrCodeDialog.vue'

export default {
  components: {
    QrCodeDialog
  },
  data() {
    return {
      actionauth: '', //功能权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Clerk/index",
      datacenter: this.$cookies.get('datacenter'),
      lists: [],
      grouplists: [], //组别列表
      localgroup: [], //当前组
      listLoading: false,
      creategroupLoading: false,
      groupLoading: false,
      creategroupeditLoading: false,
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      group: { //组别
        url: this.GLOBAL.domain + "Clerk/index",
        token: this.$cookies.get('token'),
        act: 'lists',
        name: '',
        id: '',
      },
      total_rows: 0,
      group_total_rows: 0,
      createDialog: false,
      createLoading: false,
      creategroupDialog: false, //会员组别窗口
      creategroupaddDialog: false, //新增会员组别窗口
      creategroupeditDialog: false,
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        number: '',
        birthday: '',
        phone: '',
        address: ''
      },
      updateDialog: false,
      updateLoading: false,
      update: {
        act: 'edit',
        token: this.$cookies.get('token'),
        id: '',
        name: '',
        number: '',
        birthday: '',
        phone: '',
        address: '',
        groupid: '',
      },
      clerkareaquery: {
        act: 'savecitys',
        token: this.$cookies.get('token'),
        clerkid: '',
        cityids: [],
      },

      runlogDialog: false,
      runLoading: false,
      signlists: [],
      signquery: {
        act: 'getclerksign',
        token: this.$cookies.get('token'),
        p: 1,
        rollpage: 10, // 页大小
        clerkid: 0,
      },
      total_rows: 0,
      sign_total_rows: 0,
      showmapDialog: false,

      center: '',
      zoom: '',
      autoLocationPoint: '',
      initLocation: false,
      mapLoading: false,

      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
        number: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '编号只能为数字' }
        ]
      },
      addclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },
      editclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },

      customerDialog: false,
      clerkid: '',
      clerkname: '',
      defaultcustomer: [],
      mycustomer: [],
      allclerks: [],
      localclerkid: '',
      localclerkname: '',
      editclerkLoading: false,
      iskingdee: false,

      settingkingdeeDialog: false,
      settingkingdeequery: {
        act: 'savekingdeesubmit',
        token: this.$cookies.get('token'),
        id: '',
        kingdeetype: '',
        kingdeecode: '',
      },
      isopenmall: 0,
      citylists: [],
      addareaDialog: false,
      addrealoading: false,
      citytrees: [],

      planDialog: false,
      planinfo: {
        time: '',
        time1: '',
        type: 1,
        clerkid: '',
        clerkname: '',
        clerkplan: '',
      },
      planinfotypelists: [{ id: 1, name: '按整年' }, { id: 2, name: '按月份' }],
      planquery: {
        act: 'addclerkplay',
        token: this.$cookies.get('token'),
        planlists: [],
        delplan: [],
        loading: false,
      },

      showplanDialog: false,
      showplanquery: {
        act: 'getshowplan',
        token: this.$cookies.get('token'),
        clerkid: '',
        p: 1,
        rollpage: 10,
        ischange: false,
        loading: false,
      },
      showplanlists: [],
      showplanrows: 0,
      morelists: [],
      showQrCode: false
    }
  },
  mounted() {
    this.getactionauth();
    this.getList();
    this.getNumber();
    this.getclerkgrouplists();
    this.getallclerks();
    this.creategroupDialog = false;
    this.checkiskingdee(); //查看当前代理商是否开启金蝶权限 
    this.getismall(); //查看当前是否开通线上商城权限
    this.getmorelists(); //获取更多销售员
  },
  methods: {
    downqrcode(row) {
      this.$refs.qrCodeDialogRef.initDialog(row)
    },
    //信息列表
    getmorelists() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'lists', token: this.$cookies.get('token'), p: 1, rollpage: 1000000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.morelists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },


    /** 获取线上商城开启权限 **/
    getismall() {
      var resource = this.$resource(this.GLOBAL.domain + "Goods/index");
      resource.save({ act: 'getmallopen', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.isopenmall = result.ismall;
        }
      }).catch((res) => {

      });
    },


    /** 获取城市信息列表 **/
    getcitylists(item) {
      this.clerkareaquery.clerkid = item.id;
      this.clerkareaquery.cityids = [];
      this.addareaDialog = true;
      this.addrealoading = true;

      var resource = this.$resource(this.url);
      resource.save({ act: 'getcityids', clerkid: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addrealoading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.citytrees = result.citys;
          this.clerkareaquery.cityids = result.mycitys;
          let ids = [];
          result.mycitys.forEach(function (e, i) { ids.push(e) });
          this.$refs.citytrees.setCheckedKeys(ids);
          this.addrealoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addrealoading = false;
      });
    },


    /** 保存销售员已设置的负责区域 **/
    saveclerkcitys() {
      var ids = this.$refs.citytrees.getCheckedKeys();
      this.clerkareaquery.cityids = ids;
      if (ids.length == 0) { this.$message.error("请选择业务员负责的城市"); return false; }
      var resource = this.$resource(this.url);
      resource.save(this.clerkareaquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.addareaDialog = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });

    },


    /** 查看当前代理商是否开启了金蝶权限 **/
    checkiskingdee() {
      var resource = this.$resource(this.GLOBAL.domain + "kingdee/index");
      resource.save({ act: 'isopenkingdee', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.iskingdee = result.iskingdee;
        }
      }).catch((res) => {

      });
    },

    //重置表单
    reset() {
      this.$refs.create.resetFields();
    },
    //新增
    createSave() {
      // 主动校验
      this.$refs.create.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.create).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') {
                this.$router.push('/login')
              }
              this.$message.error(res.data.Message);
              this.createLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.createDialog = false;
              this.createLoading = false;
              this.reset();
              this.getList();
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog = false;
            this.createLoading = false;
          });
        }
        else {
          return false;
        }
      });
    },
    //信息列表
    getList() {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },
    pageSizegroup(val) {
      this.group.rollpage = val;
      this.getclerkgrouplists();
    },
    pageCurrentgroup(val) {
      this.group.p = val;
      this.getclerkgrouplists();
    },

    addclerk() {
      this.$emit('listenchild', { name: '新增职员', url: 'Clerkadd' });
      //this.createDialog=true;
    },

    //编辑
    editCurrent(item) {
      this.$emit('listenchild', { name: '编辑职员', url: 'Clerkedit', data: item });

      //this.update.id=item.id;
      //this.update.name=item.name;
      //this.update.number=item.number;
      //this.update.birthday=item.birthday;
      //this.update.phone=item.phone;
      //this.update.address=item.address;
      //this.update.groupid=item.groupid;
      //this.updateDialog=true;
    },
    //更新
    updateSave() {
      // 主动校验
      this.$refs.update.validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          var resource = this.$resource(this.url);

          resource.save(this.update).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') {
                this.$router.push('/login')
              }
              this.$message.error(res.data.Message);
              this.updateLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.updateDialog = false;
              this.updateLoading = false;
              this.getList();
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.updateDialog = false;
            this.updateLoading = false;
          });
        }
        else {
          return false;
        }
      });
    },
    getNumber() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'getnumber', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.create.number = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },
    //删除
    delCurrent(item) {
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.url);
          resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') {
                  this.$router.push('/login')
                }
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功删除了' + item.name + '!');
                this.getList();
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        })
        .catch(() => {
          this.$message.info('已取消操作!');
        });
    },

    /** 获取职员组别列表 **/
    getclerkgrouplists() {
      this.creategroupDialog = true;
      this.groupLoading = true;
      this.group.act = 'getclerkgrouplists';
      var resource = this.$resource(this.group.url);
      resource.query(this.group).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.groupLoading = false;
          }
          this.$message.error(res.data.Message);
          this.groupLoading = false;
        } else {
          this.grouplists = JSON.parse(Base64.decode(res.data.Data));
          this.group_total_rows = parseInt(res.data.count);
          this.groupLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.groupLoading = false;
      });
    },

    /** 新增职员组别 **/
    creategroupadd() {
      // 主动校验
      //this.$refs.clerkrules.validate((valid) => {
      //if (valid) {
      this.creategroupLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addClerkgroup', token: this.$cookies.get('token'), name: this.localgroup.name }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
          }
          this.creategroupLoading = false;
          this.$message.error(res.data.Message);
        } else {
          this.creategroupLoading = false;
          this.creategroupaddDialog = false;
          this.getclerkgrouplists();
          this.$message.success('添加组别：' + this.localgroup.name + '成功!');
        }
      }).catch((res) => {
        this.creategroupLoading = false;
        this.creategroupaddDialog = false;
        this.$message.error(this.GLOBAL.errortext);
      });
      //}else {
      //return false;
      //}
      //});
    },

    /** 获取编辑组别信息 **/
    editgrouppercent(obj) {
      this.localgroup = [{ id: obj.id, name: obj.name }];
      this.localgroup.id = obj.id;
      this.localgroup.name = obj.name;
      this.creategroupeditDialog = true;
    },

    /** 开启或关闭会员组 **/
    changestatus(index, obj) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changestatus', token: this.$cookies.get('token'), id: obj.id, status: obj.status }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
          }
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 保存编辑职员组别 **/
    creategroupedit() {
      // 主动校验
      //this.$refs.editclerkrules.validate((valid) => {
      //if (valid) {
      this.creategroupeditLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'editClerkgroup', token: this.$cookies.get('token'), id: this.localgroup.id, name: this.localgroup.name }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.creategroupeditLoading = false;
            this.creategroupeditDialog = false;
          }
          this.creategroupeditLoading = false;
          this.creategroupeditDialog = false;
          this.$message.error(res.data.Message);
        } else {
          this.creategroupeditLoading = false;
          this.creategroupeditDialog = false;
          this.getclerkgrouplists();
          this.$message.success('修改组别名称：' + this.localgroup.name + '成功!');
        }
      }).catch((res) => {
        this.creategroupeditLoading = false;
        this.creategroupeditDialog = false;
        this.$message.error(this.GLOBAL.errortext);
      });
      //}else {
      //return false;
      //}
      //});
    },

    /** 删除组别 **/
    deletegrouppercent(obj) {
      this.$confirm('此操作将永久删除 ' + obj.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.save({ act: 'deletegroup', id: obj.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login');
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + obj.name + '!');
            this.getclerkgrouplists();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 全部职员跑店记录 **/
    runinfolistsall(item) {
      this.$emit('listenchild', { name: '职员跑店记录', url: 'Clerkrun' });
      //this.signquery.p=1;
      //this.signquery.rollpage=10;
      //this.signquery.clerkid=0;
      //this.getsignList();
      //this.runlogDialog=true;
    },

    /** 跑店签到记录 **/
    runinfolists(clerkid) {
      this.signquery.p = 1;
      this.signquery.rollpage = 10;
      this.signquery.clerkid = clerkid;
      this.getsignList();
      this.runlogDialog = true;
    },

    /** 跑店信息列表 **/
    getsignList() {
      this.runLoading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Shop/index");
      resource.query(this.signquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.signlists = JSON.parse(Base64.decode(res.data.Data));
          this.sign_total_rows = parseInt(res.data.count);
          this.runLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.runLoading = false;
      });
    },
    signpageSizeChange(val) {
      this.signquery.rollpage = val;
      this.getsignList();
    },
    signpageCurrentChange(val) {
      this.signquery.p = val;
      this.getsignList();
    },

    /** 地图展示 **/
    shopmap(lat, log, customer_name, address) {
      this.showmapDialog = true;
      //this.mapLoading=true;
      let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
      this.zoom = 15;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        _this.center = { lng: log, lat: lat };   // 设置center属性值
        _this.autoLocationPoint = { lng: log, lat: lat };   // 自定义覆盖物
        _this.initLocation = true;
      }, { enableHighAccuracy: true })

      //this.mapLoading=false;    	
    },


    /** 修改客户销售员信息 **/
    changecustomer(item) {
      this.$emit('listenchild', { name: item.name + '负责客户信息', url: 'Clerkcustomer', data: item });
      /**
      this.customerDialog=true;
      this.clerkid=item.id;
      this.clerkname=item.name;
      this.localclerkid=item.id;
      this.localclerkname=item.name;
    	
      var resource = this.$resource(this.url);
        resource.query({ act:'getclerkcustomer',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var customers = JSON.parse(Base64.decode(res.data.Data));
              this.defaultcustomer=customers.default;
              this.mycustomer=customers.my;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
        */
    },

    /** 更换职员信息 **/
    getchangeclerk() {
      var clerkid = this.localclerkid;
      var _this = this;
      this.allclerks.forEach(function (item, i) {
        if (clerkid == item.id) _this.localclerkname = item.name;
      });
    },

    /** 获取当前代理商所有的职员 **/
    getallclerks() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getallclerks', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.allclerks = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 保存职员的客户 **/
    editclerkcustomer() {
      this.editclerkLoading = true;
      if (this.clerkid == this.localclerkid) { //当前职员编辑客户信息
        var resource = this.$resource(this.url);
        resource.save({ act: 'changecustomer', oid: this.clerkid, nid: this.localclerkid, customerids: this.mycustomer, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.editclerkLoading = false;
            this.customerDialog = false;
            this.$message.success('配对客户成功');
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });

      } else { //职员客户信息移交给新的职员
        this.$confirm('您是否确认将职员：' + this.clerkname + '手里的全部客户信息移交给职员：' + this.localclerkname + '，继续?', '提示', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save({ act: 'changecustomer', oid: this.clerkid, nid: this.localclerkid, customerids: this.mycustomer, token: this.$cookies.get('token') }).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
            } else {
              this.editclerkLoading = false;
              this.customerDialog = false;
              this.$message.success('配对客户成功');
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.editclerkLoading = false;
          });

        }).catch(() => {
          this.$message.info('已取消操作!');
          this.editclerkLoading = false;
        });

      }
    },

    //职员组别管理
    getclerkgroup() {
      this.$emit('listenchild', { name: '职员组别管理', url: 'Clerkgroup' });
    },

    /** 拉起输入金蝶信息窗口 **/
    kingdeesellsubmit(item) {
      this.settingkingdeeDialog = true;
      this.settingkingdeequery.id = item.id;
      this.settingkingdeequery.kingdeetype = '';
      this.settingkingdeequery.kingdeecode = '';
    },

    /** 提交金蝶数据信息 **/
    savekingdeeinfos() {
      this.$confirm('警告：操作前请确认销售员信息是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.save(this.settingkingdeequery).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.settingkingdeeDialog = false;
            this.getList();
            this.$message.success('销售员数据提交到金蝶成功');
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    /** 新增职员月销售计划 **/
    addsellplan() {
      this.planDialog = true;
      this.planquery.planlists = [];
      this.planquery.delplan = [];
      this.planinfo.type = 1;
      this.planinfo.time = '';
      this.planinfo.time1 = '';
      this.planinfo.clerkid = '';
      this.planinfo.clerkplan = '';
    },

    /** 添加计划 **/
    addplaninfos() {
      if (this.planinfo.time1 == '' && this.planinfo.type == 1) { this.$message.error('请选择计划年份'); return false; }
      if (this.planinfo.time == '' && this.planinfo.type == 2) { this.$message.error('请选择计划月份'); return false; }
      if (this.planinfo.clerkid == '') { this.$message.error('请选择销售员'); return false; }

      if (this.planinfo.type == 1) { //按年份
        this.settingplay({ time: this.planinfo.time1 + '-01', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-02', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-03', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-04', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-05', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-06', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-07', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-08', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-09', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-10', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-11', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });
        this.settingplay({ time: this.planinfo.time1 + '-12', clerkid: this.planinfo.clerkid, money: this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '' });

      } else if (this.planinfo.type == 2) { //按月份
        var param = { time: '', clerkid: '', money: '' };
        param.time = this.planinfo.time;
        param.clerkid = this.planinfo.clerkid;
        param.money = this.planinfo.clerkplan > 0 ? this.planinfo.clerkplan : '';
        this.settingplay(param);

      }

      //调整时间顺序
      var temp = [];
      var _this = this;
      this.planquery.planlists.forEach(function (item, index) {
        item.data = _this.changetimesort(item.data);
      });
    },

    //调整数组时间顺序
    changetimesort(data) {
      var newdata = data.sort(function (a, b) { //arr就是最终的排序后的数组
        return new Date(a.month).getTime() - new Date(b.month).getTime();
      });
      return newdata;
    },


    //设置计划信息
    settingplay(datainfo) {
      var clerkname = '';
      var isexit = -1;
      var month = -1;
      var _this = this;

      this.morelists.forEach(function (item, i) {
        if (item.id == datainfo.clerkid) clerkname = item.name;
      });

      //查看该销售员是否在计划中存在
      this.planquery.planlists.forEach(function (item, index) {
        if (item.clerkid == datainfo.clerkid) {
          isexit = index;
          //若销售员已添加时查看当前添加的月份是否已存在
          item.data.forEach(function (tt, ii) {
            if (tt.month == datainfo.time) month = ii;
          })
        }
      });

      if (isexit == -1 && month == -1) { //销售员已存在但当前月份尚未添加时
        this.planquery.planlists.push({ id: '', clerkid: this.planinfo.clerkid, clerkname: clerkname, data: [{ month: datainfo.time, money: datainfo.money }] });

      } else if (isexit >= 0 && month == -1) { //销售员已存在但月份不存在
        this.planquery.planlists[isexit].data.push({ id: '', month: datainfo.time, money: datainfo.money });
      }
    },


    //修改选择时间
    changetimetype() {
      this.planinfo.time = '';
      this.planinfo.time1 = '';
    },

    //删除计划
    delplan(i, ii) {
      var _this = this;
      var data = this.planquery.planlists[i].data[ii];
      this.$delete(this.planquery.planlists[i].data, ii);
      if (this.planquery.planlists[i].data.length == 0) this.$delete(this.planquery.planlists, i);
    },

    //非取消关闭当前窗口
    closeplan() {
      this.$confirm('关闭当前窗口会造成数据丢失，你是否要关闭?', '提示', { type: 'warning' }).then(() => {
        this.planDialog = false;
      }).catch(() => {

      });
    },

    //保存新增销售员计划信息
    addclerkplans() {
      this.planquery.loading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addclerkplans', token: this.$cookies.get('token'), data: JSON.stringify(this.planquery.planlists) }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.planquery.loading = false;
        } else {
          this.planquery.loading = false;
          this.planDialog = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.planquery.loading = false;
      });
    },

    //查询销售计划
    checksellplan() {
      this.showplanDialog = true;
      this.showplanquery.clerkid = '';
      this.showplanquery.month = '';
      this.showplanquery.p = 1;
      this.showplanquery.rollpage = 10;
      this.getshowplan();
    },

    getshowplan() {
      if (this.showplanquery.ischange) {
        this.showplanquery.p = 1;
        this.showplanquery.rollpage = 10;
      }

      this.showplanquery.loading = true;
      var resource = this.$resource(this.url);
      resource.query(this.showplanquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.showplanquery.loading = false;
        } else {
          this.showplanlists = JSON.parse(Base64.decode(res.data.Data));
          this.showplanrows = parseInt(res.data.count);
          this.showplanquery.loading = false;
          if (this.showplanquery.ischange) this.showplanquery.ischange = false;

        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.showplanquery.loading = false;
      });

    },

    showplanSizeChange(val) {
      this.showplanquery.rollpage = val;
      this.getshowplan();
    },
    showplanCurrentChange(val) {
      this.showplanquery.p = val;
      this.getshowplan();
    },

    //修改计划销售金额
    changemoney(item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changemoney', token: this.$cookies.get('token'), id: item.id, money: item.money }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getshowplan();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    //删除计划销售金额
    deletemoney(item) {

      this.$confirm('你是否要删除该信息?', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.save({ act: 'deleteplan', token: this.$cookies.get('token'), id: item.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getshowplan();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });

      }).catch(() => {

      });
    },



  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.card_one {
  float: left;
  width: 100%;
  border-bottom: 1px solid #ebeef5;
}

.card_one .title {
  float: left;
  margin-left: 4%;
  width: 12%;
  padding: 8px 0 8px 0;
}

.card_one .content {
  float: left;
  width: 32%;
  padding: 8px 0 8px 0;
}

.card_one .all {
  float: left;
  width: 80%;
  padding: 8px 0 8px 0;
}

.card_one .img {
  cursor: pointer;
  float: left;
  width: 20%;
  height: 120px;
  margin: 2% 3% 0 0;
  border: 1px solid #C0C4CC;
  border-radius: 5px;
  overflow: hidden;
  background: #606266
}

.img a {
  float: left
}

.img img {
  float: left;
  width: 100%;
}

.img:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  transition: All 0.3s ease-in-out
}

.address {
  padding: 2px 2px;
}

.bm-view {
  width: 98%;
  height: 500px;
  padding: 5px;
  border: 1px solid #dddddd;
  border-radius: 6px;
}

.bm-view .BMap_Marker img {
  width: 32px;
  height: 32px;
}
.down-qr-code {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: url(../../assets/qr_code_icon.png) no-repeat center;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  margin-right: 10px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerk.vue